// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

import { Component, OnInit, OnDestroy, AfterViewInit, Input, TemplateRef, ViewChild, Output, EventEmitter, HostBinding } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatSnackBar, MatDialog } from '@angular/material';
import { fadeInOut } from '../../services/animations';
import { FormBuilder, FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { AccountService } from "../../services/account.service";
import { Car } from 'src/app/models/car.model';
import * as FileSaver from 'file-saver'; 
import { Product, GetPhotosWitPoductGroupsViewModel } from 'src/app/models/Product.model';
import { Poze } from 'src/app/models/Poze.model';
import { forEach } from '@angular/router/src/utils/collection';
import { SelectionModel } from '@angular/cdk/collections';
import { Offer, OfferDetail, PhotoDetail, OfferDetailVM, PhotoDetailVM, OfferVM } from 'src/app/models/offer.model';
import { DatePipe } from '@angular/common';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { CatalogLink } from 'src/app/models/catalogLink.model';
import { AppTranslationService } from 'src/app/services/app-translation.service';

@Component({
    selector: 'configurator',
    templateUrl: './configurator.component.html',
    styleUrls: ['./configurator.component.scss'],
    animations: [fadeInOut]
})

export class ConfiguratorComponent
{
  imageSrcCitroen: string = require("../../assets/images/citroen.png");
  imageSrcDacia: string = require("../../assets/images/dacia.png");
  imageSrcFiat: string = require("../../assets/images/fiat.png");
  imageSrcFord: string = require("../../assets/images/ford.png");
  imageSrcFuso: string = require("../../assets/images/fuso.png");
  imageSrcHyundai: string = require("../../assets/images/hyundai.png");
  imageSrcIveco: string = require("../../assets/images/iveco.png");
  imageSrcMan: string = require("../../assets/images/man.png");
  imageSrcMaxus: string = require("../../assets/images/maxus.png");
  imageSrcMaxusAstara: string = require("../../assets/images/maxusAstara.png");
  imageSrcMercedes: string = require("../../assets/images/mercedes.png");
  imageSrcNissan: string = require("../../assets/images/nissan.png");
  imageSrcOpel: string = require("../../assets/images/opel.png");
  imageSrcPeugeot: string = require("../../assets/images/peugeot.png");
  imageSrcRenault: string = require("../../assets/images/renault.png");
  imageSrcToyota: string = require("../../assets/images/toyota.png");
  imageSrcVolkswagen: string = require("../../assets/images/volkswagen.png");

  afiseazaDivLogouri: boolean = true;
  afiseazaDivSelectii: boolean = true;
  afiseazaDivBody: boolean = false;
  afiseazaDivVariant: boolean = false;
  afiseazaDivProducts: boolean = false;
  definireOffer: boolean = false;
  alegerePoze: boolean = false;
  
  dataSource: MatTableDataSource<Car>;
  offerForm: FormGroup;

  dataProducts: Product[];
  dataSelectedProducts: Product[];
  dataSelectedProductsDelete: Product[];
  dataSelectedDependentProducts: Product[];
  dataSourceProducts: MatTableDataSource<Product>;
  dataSourceProductsDependent: MatTableDataSource<Product>;
  dataSourceProductsCarReference: Product[];
  dataSourceSelectedProducts: MatTableDataSource<Product>;
  displayedColumnsProducts = ['select', 'vehicleReference', 'productgrup', 'productnumber', 'description', 'descriptionfr', 'descriptionen', 'descriptionro', 'PriceDealer', 'PriceFinalCustomer'];
  selection = new SelectionModel<Product>(true, []);
  loadingIndicator: boolean = true;
  isDataLoaded: boolean = false;
  listDependentProduct: boolean = false;

  dataPoze: Poze[];
  dataSourcePoze: MatTableDataSource<Poze>;
  dataSelectedPhoto: Poze[];
  dataSourceSelectedPhoto: MatTableDataSource<Poze>;
  displayedColumnsPoze = ['productgrup', 'reference', 'referencepoze'];
  catalogLink: CatalogLink[];

  selectiiPentruMarca: string[];
  selectiiPentruBody: string[];
  selectiiPentruVariant: string[];
  selectiiPentruDescription: string[];
  selectiiPentrucarReference: string[];
  selectiiPentruWheelbase: string[];
  selectiiPentruHeight: string[];
  selectiiPentruTransmission: string[];
  selectiiPentruProductgrup: string[];

  marcaSelectata: string;
  modelSelectat: string;
  bodySelectat: string;
  wheelbaseSelectat: string;
  heightSelectat: string;
  transmissionSelectat: string;
  variantSelectat: string;
  referenceSelectat: string;
  productgrupSelectat: string;
  carReference: string;
  productGroup: string;
  productGrup: string;
  vehicleReference: string;
  carId: string;
  offer: Offer = new Offer();
  productgrup: string = '';

  browserLang: string;
  showEN: boolean = false;
  showNI: boolean = true;
  showRO: boolean = true;
  showFR: boolean = true;
  popup: boolean = false;
  pozaAfisata: Poze;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private translate: TranslateService,
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private translationService: AppTranslationService,
    private accountService: AccountService,
    private datePipe: DatePipe,
  ) {
    this.dataSource = new MatTableDataSource<Car>();
    this.dataSourceProducts = new MatTableDataSource<Product>();
    this.dataSourceProductsDependent = new MatTableDataSource<Product>();
    this.dataSourceSelectedProducts = new MatTableDataSource<Product>();
    this.dataSourcePoze = new MatTableDataSource<Poze>();
    this.buildForm();
    translate.onLangChange.subscribe(lang => {
      this.browserLang = lang;
    })
  }

  getCatalogLinkList() {
    this.accountService.getCatalogLinkLists()
      .subscribe(results => {
        let linii = results[0];
        let liniiReconverted = JSON.parse(JSON.stringify(linii));
        this.catalogLink = liniiReconverted;
      },
        error => {
        });
  }

  selectionLanguage() {
    if (this.browserLang == "fr") {
      this.showFR = false;
      this.showEN = true;
      this.showNI = true;
      this.showRO = true;
    }
    if (this.browserLang == "en") {
      this.showFR = true;
      this.showEN = false;
      this.showNI = true;
      this.showRO = true;
    }
    if (this.browserLang == "ar") {
      this.showFR = true;
      this.showEN = true;
      this.showNI = true;
      this.showRO = false;
    }
    if (this.browserLang == "de") {
      this.showFR = true;
      this.showEN = true;
      this.showNI = false;
      this.showRO = true;
    }
  }

  ngOnInit() {
    this.afiseazaDivLogouri = true;
    this.afiseazaDivSelectii = false;
    this.afiseazaDivProducts = false;
    this.alegerePoze = false;
    this.getCatalogLinkList();
    var ddMMyyyy = this.datePipe.transform(new Date(), "dd-MM-yyyy");

    var selectedLanguage = window.selectedLanguage;
    if (selectedLanguage == null || selectedLanguage == undefined) {
      selectedLanguage = 'en';
    }
    this.translationService.changeLanguage(selectedLanguage);

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      if (event.lang != null && event.lang != "undefined") {
        selectedLanguage = event.lang;
        window.selectedLanguage = selectedLanguage;
      }
      else if (event.lang == null || event.lang == "undefined") {
        this.browserLang = selectedLanguage;
      }
      this.browserLang = selectedLanguage;
      this.selectionLanguage();
    });
    this.browserLang = selectedLanguage;
    this.selectionLanguage();
  }

  selectieMarca(marca: string) {
    this.ngOnInit();
    this.listDependentProduct = false;
    this.dataSelectedProducts = [];
    this.dataSelectedDependentProducts = [];
    this.marcaSelectata = marca;
    this.offer = new Offer()
    this.offer.subject = '';
    this.offer.clientName = '';

    this.accountService
      .getCarsConfiguratorLists(marca)
      .subscribe(results => {

        let linii = results[0];

        let liniiReconverted = JSON.parse(JSON.stringify(linii));

        this.selectiiPentruMarca = new Array();

        for (let car of liniiReconverted) {
          if (!this.selectiiPentruMarca.includes(car.model)) {
            this.selectiiPentruMarca.push(car.model);
          }
        }

        this.afiseazaDivLogouri = false;
        this.afiseazaDivSelectii = true;
      },

        error => {
          this.afiseazaDivLogouri = true;
          this.afiseazaDivSelectii = false;
        });

    }

  onModelSelected(modelSelectat: string) {
    this.modelSelectat = modelSelectat;
    this.bodySelectat = undefined;
    this.variantSelectat = undefined;
    this.wheelbaseSelectat = undefined;
    this.heightSelectat = undefined;
    this.transmissionSelectat = undefined;

    this.dataProducts = [];
    this.dataSourceProducts.data = this.dataProducts;
    this.dataSourceProductsCarReference = this.dataProducts;

    this.accountService
      .getCarsConfiguratorLists(this.marcaSelectata, this.modelSelectat)
        .subscribe(results => {

          let linii = results[0];

          let liniiReconverted = JSON.parse(JSON.stringify(linii));

          this.selectiiPentruBody = new Array();

          for (let car of liniiReconverted) {
            if (!this.selectiiPentruBody.includes(car.body)) {
              this.selectiiPentruBody.push(car.body);
            }
          }


          this.afiseazaDivLogouri = false;
          this.afiseazaDivSelectii = true;
      },

          error => {
            this.afiseazaDivLogouri = true;
            this.afiseazaDivSelectii = false;
          });
  }
  
  onBodySelected(bodySelectat: string) {
    this.bodySelectat = bodySelectat;
    this.variantSelectat = undefined;
    this.wheelbaseSelectat = undefined;
    this.heightSelectat = undefined;
    this.transmissionSelectat = undefined;

    this.dataProducts = [];
    this.dataSourceProducts.data = this.dataProducts;
    this.dataSourceProductsCarReference = this.dataProducts;

    this.accountService
      .getCarsConfiguratorLists(this.marcaSelectata, this.modelSelectat, this.bodySelectat)
      .subscribe(results => {

        let linii = results[0];

        let liniiReconverted = JSON.parse(JSON.stringify(linii));
        
        this.selectiiPentruVariant = new Array();

        for (let car of liniiReconverted) {
          if (!this.selectiiPentruVariant.includes(car.variant)) {
            this.selectiiPentruVariant.push(car.variant);
          }
        }

        this.afiseazaDivLogouri = false;
        this.afiseazaDivSelectii = true;
      },
        error => {
          this.afiseazaDivLogouri = true;
          this.afiseazaDivSelectii = false;
        });
  }

  onVariantSelected(variantSelectat: string) {
    this.variantSelectat = variantSelectat;
    this.wheelbaseSelectat = undefined;
    this.heightSelectat = undefined;
    this.transmissionSelectat = undefined;

    this.dataProducts = [];
    this.dataSourceProducts.data = this.dataProducts;
    this.dataSourceProductsCarReference = this.dataProducts;

    this.accountService
      .getCarsConfiguratorLists(this.marcaSelectata, this.modelSelectat, this.bodySelectat, this.variantSelectat)
      .subscribe(results => {

              let linii = results[0];

              let liniiReconverted = JSON.parse(JSON.stringify(linii));

        this.selectiiPentruWheelbase = new Array();

              for (let car of liniiReconverted) {
                if (!this.selectiiPentruWheelbase.includes(car.wheelbase)) {
                  this.selectiiPentruWheelbase.push(car.wheelbase);
                }
              }

              this.afiseazaDivLogouri = false;
              this.afiseazaDivSelectii = true;
            },
              error => {
                this.afiseazaDivLogouri = true;
                this.afiseazaDivSelectii = false;
              });
        }

  onWheelbaseSelected(wheelbaseSelectat: string) {
    this.wheelbaseSelectat = wheelbaseSelectat;
    this.heightSelectat = undefined;
    this.transmissionSelectat = undefined;

    this.dataProducts = [];
    this.dataSourceProducts.data = this.dataProducts;
    this.dataSourceProductsCarReference = this.dataProducts;

    this.accountService
      .getCarsConfiguratorLists(this.marcaSelectata, this.modelSelectat, this.bodySelectat, this.variantSelectat, this.wheelbaseSelectat)
      .subscribe(results => {

        let linii = results[0];

        let liniiReconverted = JSON.parse(JSON.stringify(linii));

        this.selectiiPentruHeight = new Array();

        for (let car of liniiReconverted) {
          if (!this.selectiiPentruHeight.includes(car.height)) {
            this.selectiiPentruHeight.push(car.height);
          }
        }

        this.afiseazaDivLogouri = false;
        this.afiseazaDivSelectii = true;
      },
        error => {
          this.afiseazaDivLogouri = true;
          this.afiseazaDivSelectii = false;
        });
  }

  onHeightSelected(heightSelectat: string) {
    this.heightSelectat = heightSelectat;
    this.transmissionSelectat = undefined;

    this.dataProducts = [];
    this.dataSourceProducts.data = this.dataProducts;
    this.dataSourceProductsCarReference = this.dataProducts;

    this.accountService
      .getCarsConfiguratorLists(this.marcaSelectata, this.modelSelectat, this.bodySelectat, this.variantSelectat, this.wheelbaseSelectat, this.heightSelectat)
      .subscribe(results => {

        let linii = results[0];

        let liniiReconverted = JSON.parse(JSON.stringify(linii));

        this.selectiiPentruTransmission = new Array();

        for (let car of liniiReconverted) {
          if (!this.selectiiPentruTransmission.includes(car.transmission)) {
            this.selectiiPentruTransmission.push(car.transmission);
          }
        }

        this.afiseazaDivLogouri = false;
        this.afiseazaDivSelectii = true;
      },
        error => {
          this.afiseazaDivLogouri = true;
          this.afiseazaDivSelectii = false;
        });
  }

  onTransmissionSelected(transmissionSelectat: string) {
    this.transmissionSelectat = transmissionSelectat;

    this.dataProducts = [];
    this.dataSourceProducts.data = this.dataProducts;
    this.dataSourceProductsCarReference = this.dataProducts;

    this.accountService
      .getCarsConfiguratorLists(this.marcaSelectata, this.modelSelectat, this.bodySelectat, this.variantSelectat, this.wheelbaseSelectat, this.heightSelectat, this.transmissionSelectat)
      .subscribe(results => {

        let linii = results[0];

        let liniiReconverted = JSON.parse(JSON.stringify(linii));
 
        let car = liniiReconverted as Car[];

       

        this.carReference = car[0].modelAccess;
        this.carId = car[0].id.toString();

        this.afiseazaDivLogouri = false;
        this.afiseazaDivSelectii = true;

        this.accountService
          .getProductLists("undefined", "undefined", this.carReference, "undefined", "undefined", "undefined", this.productgrupSelectat, "undefined", "undefined", "undefined", "undefined", "undefined", "undefined", this.marcaSelectata)
          .subscribe(results => {
            let linii = results[0];

            let liniiReconverted = JSON.parse(JSON.stringify(linii));

            this.dataProducts = liniiReconverted;

            this.dataSourceProducts.data = this.dataProducts;
            this.dataSourceProductsCarReference = this.dataProducts;

            this.afiseazaDivProducts = true;

            this.alegerePoze = false;

            this.isDataLoaded = true;

            setTimeout(() => { this.loadingIndicator = false; }, 1500);
          });

        this.selectiiPentruProductgrup = new Array();
      },
        error => {
          this.afiseazaDivLogouri = true;
          this.afiseazaDivSelectii = false;
          this.afiseazaDivProducts = false;
          this.alegerePoze = false;
        });
  }

  onProductgrupSelected(productgrupSelectat: string) {
    this.productgrupSelectat = productgrupSelectat;

    this.accountService
      .getProductLists("undefined", "undefined", this.carReference, "undefined", "undefined", "undefined", this.productgrupSelectat, "undefined", "undefined", "undefined", "undefined", "undefined", "undefined", this.marcaSelectata)
      .subscribe(results => {

        let linii = results[0];

        let liniiReconverted = JSON.parse(JSON.stringify(linii));

        this.dataProducts = liniiReconverted;

        for (let product of this.dataProducts) {
          for (let selectedProduct of this.dataSelectedProducts) {
            if (product.id == selectedProduct.id) {
              product.selected = true;
            }
          }
          for (let selectedProduct of this.dataSelectedDependentProducts) {
            if (product.id == selectedProduct.id) {
              product.selectedDependentProduct = true;
            }
          }
        }

        this.dataSourceProducts.data = this.dataProducts;

        this.afiseazaDivLogouri = false;
        this.afiseazaDivSelectii = true;
      },
        error => {
          this.afiseazaDivLogouri = true;
          this.afiseazaDivSelectii = false;
        });
  }

    cancel() {
      this.afiseazaDivLogouri = true;
      this.afiseazaDivSelectii = false;
      this.afiseazaDivProducts = false;
      this.selectiiPentruMarca = null;
      this.selectiiPentruBody = null;
      this.selectiiPentruVariant = null;
      this.selectiiPentruWheelbase = null;
      this.selectiiPentruHeight = null;
      this.selectiiPentruTransmission = null;
      this.selectiiPentruProductgrup = null;
      this.carReference = null;
      this.alegerePoze = null;
      this.modelSelectat = undefined;
  }

  getTotalpricedealer() {
    if (this.dataProducts) {
      return this.dataProducts.map(p => p.pricedealer).reduce((a, value) => a + value, 0);
    }
    return 0;
  } 

  saveOffer() {
    this.definireOffer = true;
    let newOffer = new OfferVM();
    newOffer.id = '0';
    newOffer.carId = this.carId;
    newOffer.status = 'A';
    newOffer.offerDetails = [];
    newOffer.offerPhotos = [];
    newOffer.subject = this.offer.subject;
    newOffer.clientName = this.offer.clientName;

    let mesajAvertizare = 'Subject is mandatory!';
    let mesajAvertizareClientName = 'Client name is mandatory!';
    
    if (this.offer.subject === '') {
      this.saveFailedHelper(mesajAvertizare);
      return;
    }

    if (this.offer.clientName === '') {
      this.saveFailedHelper(mesajAvertizareClientName);
      return;
    }

    for (let product of this.dataSelectedProducts.filter(f => f.selected === true)) {
      let offerDetail = new OfferDetailVM;
      offerDetail.productId = product.id;
      newOffer.offerDetails.push(offerDetail);
    }
 
    for (let photo of this.dataPoze.filter(poza => poza.selected === true)) {
      let photoDetail = new PhotoDetailVM;
      photoDetail.photoId = photo.id;
      newOffer.offerPhotos.push(photoDetail);
    }
    
    this.accountService.saveOffer(newOffer).subscribe(
      role => this.saveSuccessHelper(this.offer, `Offer saved successfully!`),
      error => this.saveFailedHelper(error));

    this.afiseazaDivLogouri = true;
    this.alegerePoze = false;
  }

  private saveSuccessHelper(offer?: Offer, mesaj?: string) {
    this.alertService.stopLoadingMessage();
     
    this.alertService.showMessage("Success", mesaj, MessageSeverity.success);
  }

  private saveFailedHelper(error: any) {
    this.alertService.stopLoadingMessage();
    this.alertService.showStickyMessage("Save Error", "Errors: ", MessageSeverity.error, error);
    this.alertService.showStickyMessage(error, null, MessageSeverity.error);
  }

  private afiseazaPdf(product: Product) {
    var cautare = this.catalogLink.find(f => f.catalogReference == product.catalogreference);
    if (this.browserLang == "fr") {
      window.open(cautare.linkCatalogFr, '_blank');
    }
    if (this.browserLang == "en") {
      window.open(cautare.linkCatalogEn, '_blank');
    }
    if (this.browserLang == "ar") {
      window.open(cautare.linkCatalogRo, '_blank');
    }
    if (this.browserLang == "de") {
      window.open(cautare.linkCatalogNl, '_blank');
    }
  }

  private afiseazaPoza(product: Product) {
    let poza = this.carReference + "_" + product.productnumber + ".pdf";
    window.open(poza, '_blank');
  }

  urmatorul() {
    this.dataSourceSelectedProducts.data = this.dataSelectedProducts;

    let getPhotosWitPoductGroupsViewModel = new GetPhotosWitPoductGroupsViewModel();
    getPhotosWitPoductGroupsViewModel.carReference = this.carReference;
    getPhotosWitPoductGroupsViewModel.productList = this.dataSelectedProducts;

    this.accountService
      .getPhotosWitPoductGroupsViewModel(getPhotosWitPoductGroupsViewModel)
      .subscribe(results => {

        let linii = results;

        let liniiReconverted = JSON.parse(JSON.stringify(linii));
        
        this.dataPoze = liniiReconverted;
        

        for (let poza of this.dataPoze) {
          poza.selected = false;
        }

        this.dataSourcePoze.data = this.dataPoze;

        this.isDataLoaded = true;

        setTimeout(() => { this.loadingIndicator = false; }, 1500);

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
        error => {
        });

    

    this.alegerePoze = true;
    this.afiseazaDivSelectii = false;
    this.afiseazaDivProducts = false;
  }

  cancel1() {
    this.alegerePoze = false;
    this.afiseazaDivSelectii = true;
    this.afiseazaDivProducts = true;
  }

  GetPhotoUrl(poza: Poze): string {
    return '/' + poza.vehicleReference + "_" + poza.photoReference + "_" + poza.id + ".jpg";
  }

  SelectPhoto(poza: Poze) {
    poza.selected = !poza.selected;
  }

  getDependentProductsList() {
    for (let product of this.dataProducts) {
      for (let selectedProduct of this.dataSelectedDependentProducts) {
        if (product.id == selectedProduct.id) {
          this.listDependentProduct = false;
          product.selectedDependentProduct = false;
          product.selected = false;
        }
      }
    }

    this.dataSelectedDependentProducts.forEach((product) => {
      this.dataSelectedProducts = this.dataSelectedProducts.filter(f => f.id != product.id);
    });
    
    this.dataSelectedDependentProducts = [];
    
    this.dataSelectedProducts.forEach((product) => {
      if (product.depedentProduct !== null) {
        let idProducts = product.depedentProduct.split('#');

        for (var i = 0; i <= idProducts.length; i++) {
          if (this.dataSourceProductsCarReference !== undefined) {
            let productInList = this.dataSourceProductsCarReference.find(f => f.id == idProducts[i]);
            if (productInList != null) {
              this.dataSelectedProducts.push(productInList);
              this.dataSelectedDependentProducts.push(productInList);
              productInList.selected = true;
            }
          }
        }

        for (let product of this.dataProducts) {
          for (let selectedProduct of this.dataSelectedProducts) {
            if (product.id == selectedProduct.id) {
              product.selected = true;
            }
          }

          for (let selectedProduct of this.dataSelectedDependentProducts) {
            if (product.id == selectedProduct.id) {
              this.listDependentProduct = true;
              product.selectedDependentProduct = true;
            }
          }
        }
      }
    });
    this.dataSelectedDependentProducts = this.dataSelectedDependentProducts.filter((item, i, ar) => ar.indexOf(item) === i);
    this.dataSelectedProducts = this.dataSelectedProducts.filter((item, i, ar) => ar.indexOf(item) === i);
    this.dataSourceProductsDependent.data = this.dataSelectedDependentProducts;
  }

  markSelectionOfProduct(product: Product) {
    let currentProductInList = this.dataSelectedProducts.find(f => f.id === product.id);

    if (product.selected) {
      if (currentProductInList == null) {
        this.dataSelectedProducts.push(product);
      }
    }
    else {
      if (currentProductInList !== null) {
        this.dataSelectedProducts = this.dataSelectedProducts.filter(obj => obj !== currentProductInList);
      }
    }
    this.getDependentProductsList();
  }

  private buildForm() {
    this.offerForm = this.formBuilder.group({
      tbSubject: ['', [Validators.required],]
    });
  }

  get tbSubject() {
    return this.offerForm.get('tbSubject');
  }
  
  showPicture(poza: Poze) {
    this.pozaAfisata = poza;
    this.popup = true;
  }
}

